import styled from 'styled-components';

const ProBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.9), rgba(79, 70, 229, 0.9));
  color: white;
  font-size: 0.8rem;
  font-weight: bold;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  margin-left: 0.75rem;
  box-shadow: 0 0 10px rgba(99, 102, 241, 0.5);
  animation: pulse 2s infinite;
  position: relative;
  z-index: 1;
  &::before {
    content: '★';
    margin-right: 0.25rem;
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: inherit;
    border-radius: inherit;
    filter: blur(5px);
    z-index: -1;
    opacity: 0.5;
  }
  @keyframes pulse {
    0% { box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.7); }
    70% { box-shadow: 0 0 0 10px rgba(99, 102, 241, 0); }
    100% { box-shadow: 0 0 0 0 rgba(99, 102, 241, 0); }
  }
`;

export default ProBadge; 